import type { GridColumn } from '@glideapps/glide-data-grid';

export const ROW_BUFFER = 1000;

type Column<T> = Omit<GridColumn, 'id'> & { id: T; width?: number };

type Columns = [
  Column<'ticker'>,
  Column<'type'>,
  Column<'date'>,
  Column<'shares'>,
  Column<'price'>,
  Column<'cost'>,
  Column<'transactionId'>,
];

export const COLUMNS: Columns = [
  {
    title: 'Ticker',
    id: 'ticker',
    grow: 1,
  },
  {
    title: 'Transaction type',
    id: 'type',
    grow: 1,
  },
  {
    title: 'Date',
    id: 'date',
    grow: 1,
  },
  {
    title: 'Shares',
    id: 'shares',
    grow: 1,
  },
  {
    title: 'Price',
    id: 'price',
    grow: 1,
  },
  {
    title: 'Total cost',
    id: 'cost',
    grow: 1,
  },
  {
    title: 'Transaction Id',
    id: 'transactionId',
    width: 0, // hidden column
  },
];

export const COLUMN_IDS = COLUMNS.map((column) => column.id);

// TODO: Replace usage with this? import { getCSSVar } from '@simplywallst/ui-core/next';
// We're hardcoding theme vars as it is hard to access css vars for canvas use and styled-components theme will eventually be removed
export const THEME = {
  fontFamily: `'Roboto', -apple-system, system-ui, BlinkMacSystemFont, 'Segoe UI', 'Helvetica Neue', Arial, sans-serif`,
  headerFontStyle: 'bold 14px',
  accentColor: 'rgba(35, 148, 223, 1)',
  accentLight: 'rgba(35, 148, 223, 0.1)',
  cellHorizontalPadding: 12,
  textLight: 'rgba(27, 34, 45, 0.5)',
  textMedium: 'rgba(27, 34, 45, 0.7)',
};
